export const changeToIntString = (change: number | undefined) =>
  change ? `${change > 0 ? '+' : '-'}${Math.abs(change)}` : undefined;
